// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"6b08f385","313":"96ea1094","322":"697e73cb","422":"8017f441","558":"3a2ab5ac","574":"40a39973","654":"064ff4f3","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};